import React from 'react';

import { usePlayerContext } from 'src/store/player';
import JourneyPlayerLogo from '../JourneyPlayerLogo';
import JourneyPersonalizationLogo from './logo';

interface Props {
  logoClasses?: string;
}

const JourneyPlayerPersonalizationContainer = ({ logoClasses }: Props) => {
  const journey = usePlayerContext((state) => state.journey);
  return (
    <div className='flex flex-1 divide-x-2 space-x-2'>
      <JourneyPlayerLogo journey={journey} linkClasses="self-center" logoClasses={logoClasses} />
      <JourneyPersonalizationLogo journey={journey} />
    </div>
  );
};

export default JourneyPlayerPersonalizationContainer;
